import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {BodyComponent} from './body.component';

@NgModule({
	imports: [CommonModule, FormsModule],
	declarations: [BodyComponent],
	exports: [BodyComponent],
	entryComponents: [BodyComponent]
})
export class BodyModule {
}

export {BodyComponent} from './body.component';
